'use strict';

import axios from 'axios';

export const clientWithoutInterceptors = axios.create({});
